import { render } from "./JsPanel.vue?vue&type=template&id=f68e194e"
import script from "./JsPanel.vue?vue&type=script&lang=js"
export * from "./JsPanel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\20210603\\Downloads\\vue3-js-panel\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__